import React from "react";
import { Calculator, Users, Search, Layers, LineChart, Newspaper } from "lucide-react";

const TABS = [
  { id: "trade", label: "Trade", icon: Calculator, testId: "mobile-tab-trade" },
  { id: "league", label: "League", icon: Users, testId: "mobile-tab-league" },
  { id: "news", label: "News", icon: Newspaper, testId: "mobile-tab-news" },
  { id: "lookup", label: "Lookup", icon: Search, testId: "mobile-tab-lookup" },
  { id: "tiers", label: "Tiers", icon: Layers, testId: "mobile-tab-tiers" },
  { id: "track", label: "Track", icon: LineChart, testId: "mobile-tab-track" },
];

export function MobileToolNav({ activeTool, onToolChange }) {
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-[#0A0A0A] bg-white pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-tool-nav"
      aria-label="Tools"
    >
      <div className="grid grid-cols-6">
        {TABS.map(({ id, label, icon: Icon, testId }) => {
          const active = activeTool === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onToolChange(id)}
              className={`flex flex-col items-center justify-center gap-0.5 py-2 min-h-[52px] text-[9px] uppercase tracking-wider font-semibold transition-colors ${
                active ? "text-[#7C3AED] bg-[#F3F4F6]" : "text-[#52525B]"
              }`}
              data-testid={testId}
            >
              <Icon size={18} strokeWidth={active ? 2.5 : 2} />
              <span>{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
